import { formatMeterDelta, MeterType } from "@next-platform/packages-ts-types";
import MeterMoveDirection from "./MeterMoveDirection";
/** Net movement of one meter in this snapshot; dice report their new face instead. Clocks don't animate. */
const resolveMeterMove = ({ meter, snapshot, isArrived, }) => {
    const hudMeter = isArrived ? snapshot.meta.meters?.[meter.id] : undefined;
    if (meter.type === MeterType.CLOCK || hudMeter?.delta === undefined) {
        return null;
    }
    if (meter.type === MeterType.DICE) {
        return { delta: 0, text: String(hudMeter.value), direction: MeterMoveDirection.Roll };
    }
    const delta = hudMeter.delta;
    if (delta === 0) {
        return null;
    }
    return { delta, text: formatMeterDelta(meter, delta), direction: delta < 0 ? MeterMoveDirection.Down : MeterMoveDirection.Up };
};
export default resolveMeterMove;
